import React from "react";
import BaseComponent from "../BaseComponent";
import styled from "styled-components";
import nota from "../Global/nota.guidelines.json";
import NanoFlex from "../Global/NanoFlex.js";
import { validateEmailFormat } from "../Global/tools.js";

import accountService from "../../services/AccountService.js";

import Button from "../Nano/Buttons/Button.js";
import Spinner from "../Nano/Spinner.js";
import Type from "../Global/Typography.js";
import Input from "../Nano/Input.js";
import TitleCard from "../Nano/TitleCard.js";
import Grid from "../Macro/Grid.js";
import WrapperList from "../Nano/WrapperList.js";

//IMAGES
import { ReactComponent as Password } from "../Global/Icons/password.svg";
import { ReactComponent as Warning } from "../Global/Icons/warning.svg";
import { ReactComponent as Check } from "../Global/Icons/check.svg";

const multiple = nota.global.multiple;

const PasswordManagementModalStyle = styled.div`
  width: 400px;
  background-color: ${nota.color.neutral.white};
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  padding: ${multiple * 3 + "px"};
  .headerModal {
    padding-bottom: ${multiple + "px"};
    border-bottom: 0.5px solid ${nota.color.neutral.NeuFour};
    svg {
      height: 16px;
      width: 16px;
      path {
        fill: ${nota.color.main.default};
      }
    }
    h3 {
      margin-left: ${multiple + "px"};
      text-transform: uppercase;
      b {
        color: ${nota.color.main.default};
      }
    }
  }
  .modalContainer {
    .modalWrapper {
      padding: ${multiple * 3 + "px"} 0;
    }
  }
  .loadingContainer {
    min-height: 406px;
  }

  .btnsContainer {
    padding: 16px 8px 0 8px;
    border-top: 0.5px solid ${nota.color.neutral.NeuFour};
    .cta {
      margin: 0;
    }
  }

  .formContainer {
    width: 300px;
    height: auto;
    margin-bottom: ${multiple * 3 + "px"};
    .inputContainer {
      width: 100%;
      margin: 0;
      .inputWrapper {
        height: auto;
        .eye {
          width: auto;
          height: auto;
          margin-bottom: 9px;
          margin-right: 8px;
        }
      }
    }
    .forgotBtn {
      .simpleButtonWrapper {
        button {
          padding: 0;
        }
      }
    }
    &:last-child {
      margin-bottom: 0;
    }
  }

  .formRecover {
    .formHeader {
      margin-top: 96px;
      margin-bottom: 24px;
    }
    .notificationsWrapper {
      height: 43px;
      margin-bottom: 96px;
    }
  }

  /* NOTIFICATION */
  .wrapperNotification {
    height: 380px;
    .iconWrapper {
      padding: 72px 72px 0px 72px;
      svg {
        height: 100px;
        width: auto;
      }
    }
    .infoNotification {
      text-align: center;
      padding: ${multiple * 2 + "px"};
      h3 {
        color: ${nota.color.neutral.NeuOne};
        text-transform: uppercase;
        font-weight: bold;
      }
    }
  }

  .alertNotificationContainer {
    height: 43px;
  }

  .alertNotificationWrapper {
    height: auto;
    width: 100%;

    .alertWrapper {
      padding: ${multiple + "px"};
      .iconWrapper {
        width: auto;
        margin: 0 ${multiple * 2 + "px"};
        svg {
          width: auto;
          height: 25px;
        }
      }
    }
  }

  .errorNotification {
    border: 1px solid ${nota.color.main.mTwo};
    margin-bottom: ${multiple * 2 + "px"};
    .iconWrapper {
      svg {
        path {
          fill: ${nota.color.main.mTwo};
        }
      }
    }
    .notificationWrapper {
      p {
        color: ${nota.color.main.mTwo};
      }
    }
  }

  .sucessNotification {
    border: 1px solid ${nota.color.main.default};
    .iconWrapper {
      svg {
        path {
          fill: ${nota.color.main.default};
        }
      }
    }
    .notificationWrapper {
      p {
        color: ${nota.color.main.default};
      }
    }
  }

  /* MEDIA QUERIES */
  @media only screen and (max-width: 520px) {
    width: 90vw;
    .modalContainer {
      .modalWrapper {
        padding: 8px 0;
      }
    }
    .formContainer {
      width: 100%;
    }
    .btnsContainer {
      flex-direction: column;
      .buttonWrapper {
        order: 1;
      }
      .simpleButtonWrapper {
        order: 2;
        margin-top: ${multiple + "px"};
      }
    }
  }

  @media only screen and (max-height: 630px) {
    .headerModal {
      h3 {
        font-size: 16px;
      }
    }
    .alertNotificationContainer {
      height: auto;
      min-height: 36px;
    }
    .errorNotification {
      margin-bottom: 8px;
      .alertWrapper {
        padding: 4px;
        .iconWrapper {
          svg {
            height: 16px;
          }
        }
      }
    }
    .formContainer {
      margin-bottom: 8px;
    }
  }

  @media only screen and (max-height: 630px) {
    .formRecover {
      .formHeader {
        margin-top: 54px;
      }
      .notificationsWrapper {
        margin-bottom: 54px;
      }
    }
    .wrapperNotification {
      height: 336px;
    }
  }
`;

export class PasswordManagementModal extends BaseComponent {
  constructor(props) {
    super(props);

    this.state = this.getDefaultState();
  }

  getDefaultState = () => {
    return {
      oldPassword: "",
      oldPasswordError: false,

      newPassword: "",
      newPasswordError: false,

      repeatNewPassword: "",
      repeatNewPasswordError: false,

      status: null,
      statusMessage: "",

      showRecoverPassword: false,
      recoverPasswordEmail: "",
      recoverPasswordEmailError: false,
      recoverPasswordStatus: null,
      recoverPasswordDisabled: false,
    };
  };

  componentDidMount() {
    super.componentDidMount();
  }

  componentWillUnmount() {
    super.componentWillUnmount();
  }

  validateFields = () => {
    let oldPasswordError = false;
    let newPasswordError = false;
    let repeatNewPasswordError = false;
    let isValid = true;
    if (!this.state.oldPassword || this.state.oldPassword.trim() == "") {
      oldPasswordError = true;
      isValid = false;
    }
    if (!this.state.newPassword || this.state.newPassword.trim() == "") {
      newPasswordError = true;
      isValid = false;
    }
    if (!this.state.repeatNewPassword || this.state.repeatNewPassword.trim() == "") {
      repeatNewPasswordError = true;
      isValid = false;
    }
    if (this.state.newPassword !== this.state.repeatNewPassword) {
      repeatNewPasswordError = true;
      isValid = false;
    }

    this.setState({
      oldPasswordError: oldPasswordError,
      newPasswordError: newPasswordError,
      repeatNewPasswordError: repeatNewPasswordError,
    });

    return isValid;
  };

  changePassword = () => {
    if (this.validateFields()) {
      accountService
        .changePassword(this.state.oldPassword, this.state.newPassword)
        .then((response) => {
          if (response.ok == false) {
            // Catch
            if ((response.status === 403 || response.status === 401)) window.dispatchEvent(new Event("sendToLogin"));
          }
          return response.json();
        })
        .then((data) => {
          let immutableState = { ...this.state };
          immutableState.statusMessage = data.message;
          immutableState.status = data.ok;
          this.setState(immutableState);
        });
    }
  };

  cancel = () => {
    this.setState(this.getDefaultState());
    if (this.props.cancelAction) this.props.cancelAction();
  };

  continue = () => {
    this.setState(this.getDefaultState());
    if (this.props.nextAction) this.props.nextAction();
  };

  /*Recover Password */

  recoverPasswordSubmit = (event) => {
    // Prevent page refresh
    event.preventDefault();
    this.setState({ recoverPasswordDisabled: true }, () => {
      if (validateEmailFormat(this.state.recoverPasswordEmail)) {
        accountService
          .recoverPassword(this.state.recoverPasswordEmail)
          .then((response) => {
            if (response.ok) {
              return response.json();
            } else {
              // Catch
              if ((response.status === 403 || response.status === 401)) window.dispatchEvent(new Event("sendToLogin"));
            }
          })
          .then((data) => {
            this.setState({ recoverPasswordStatus: data ? true : false, recoverPasswordEmailError: data ? false : true, recoverPasswordDisabled: false });
          });
      } else {
        this.setState({ recoverPasswordEmailError: true, recoverPasswordDisabled: false });
      }
    });
  };

  onRecoverPasswordEmailChange = (value) => {
    this.setState({ recoverPasswordEmail: value });
  };

  cancelRecoverPassword = () => {
    this.setState({ showRecoverPassword: false, recoverPasswordEmail: "", recoverPasswordStatus: null, recoverPasswordEmailError: false });
  };

  render() {
    return (
      <PasswordManagementModalStyle>
        <NanoFlex className="headerModal" justifyContent="flex-start">
          <Password />
          <Type.h3>
            <b>{this.translation.passwordManagement.title}</b>
          </Type.h3>
        </NanoFlex>

        {!this.state.showRecoverPassword && (
          <NanoFlex className="modalContainer passwordManagementContainer" flexDirection={"column"} justifyContent="space-between" alignContent="space-between">
            {this.state.status !== true && (
              <NanoFlex className="modalWrapper" flexDirection={"column"}>
                <NanoFlex className="formsWrapper" flexDirection={"column"}>
                  {/*ERROR NOTIFICATION*/}
                  <NanoFlex className="alertNotificationContainer">
                    {this.state.status === false && (
                      <NanoFlex className="alertNotificationWrapper errorNotification">
                        <NanoFlex className="alertWrapper">
                          <NanoFlex className="iconWrapper">
                            <Warning />
                          </NanoFlex>
                          <NanoFlex className="notificationWrapper" justifyContent={"flex-start"} alignContent={"flex-start"}>
                            <Type.p>{this.state.statusMessage}</Type.p>
                          </NanoFlex>
                        </NanoFlex>
                      </NanoFlex>
                    )}
                    {/*END ERROR NOTIFICATION*/}
                  </NanoFlex>

                  <NanoFlex className="formContainer" flexDirection={"column"}>
                    <Input
                      type="text"
                      title={this.translation.passwordManagement.oldPassword}
                      placeholder={this.translation.passwordManagement.oldPassword}
                      eye={true}
                      defaultValue={this.state.oldPassword}
                      error={this.state.oldPasswordError}
                      onChangeAction={(val) => {
                        this.setState({ oldPassword: val });
                      }}
                    />
                    <NanoFlex className="forgotBtn" justifyContent={"flex-end"}>
                      <Button label={this.translation.passwordManagement.forgotPassword} type={"button"} simple clickAction={() => this.setState({ showRecoverPassword: true })} />
                    </NanoFlex>
                  </NanoFlex>
                  <NanoFlex className="formContainer" flexDirection={"column"}>
                    <Input
                      title={this.translation.passwordManagement.newPassword}
                      placeholder={this.translation.passwordManagement.newPassword}
                      eye={true}
                      defaultValue={this.state.newPassword}
                      error={this.state.newPasswordError}
                      onChangeAction={(val) => {
                        this.setState({ newPassword: val });
                      }}
                    />
                    <Input
                      title={this.translation.passwordManagement.repeatNewPassword}
                      placeholder={this.translation.passwordManagement.repeatNewPassword}
                      eye={true}
                      defaultValue={this.state.repeatNewPassword}
                      error={this.state.repeatNewPasswordError}
                      onChangeAction={(val) => {
                        this.setState({ repeatNewPassword: val });
                      }}
                    />
                  </NanoFlex>
                </NanoFlex>
                <NanoFlex className="alertNotificationContainer"></NanoFlex>
              </NanoFlex>
            )}

            {/*SUCESS NOTIFICATION*/}
            {this.state.status === true && (
              <NanoFlex className="wrapperNotification" flexDirection="column">
                <NanoFlex className="iconWrapper">
                  <Check />
                </NanoFlex>

                <NanoFlex className="infoNotification">
                  <Type.h3>{this.translation.passwordManagement.passwordChangedMessage}</Type.h3>
                </NanoFlex>
              </NanoFlex>
            )}
            {this.state.status !== true && (
              <NanoFlex className="btnsContainer" alignContent={"flex-end"}>
                <Button label={this.translation.geral.cancel} simple clickAction={this.cancel} />
                <Button label={this.translation.geral.confirm} clickAction={this.changePassword} />
              </NanoFlex>
            )}
            {this.state.status === true && (
              <NanoFlex className="btnsContainer" alignContent={"flex-end"}>
                <Button label={this.translation.geral.continue} clickAction={this.continue} />
              </NanoFlex>
            )}
          </NanoFlex>
        )}

        {this.state.showRecoverPassword && (
          <form className="form-wrapper formRecover" onSubmit={this.recoverPasswordSubmit}>
            {!this.state.recoverPasswordStatus && (
              <NanoFlex className="formHeader" flexDirection={"column"} justifyContent="flex-start" alignItems="flex-start" alignContent="flex-start">
                <Type.h2 dangerouslySetInnerHTML={{ __html: this.translation.passwordManagement.recoverPassword.title }}></Type.h2>
                <Type.p>{this.translation.passwordManagement.recoverPassword.subTitle}</Type.p>
              </NanoFlex>
            )}
            {!this.state.recoverPasswordStatus && (
              <Input
                id={0}
                title={this.translation.passwordManagement.recoverPassword.email}
                placeholder={this.translation.passwordManagement.recoverPassword.email}
                defaultValue={this.state.recoverPasswordEmail}
                error={this.state.recoverPasswordEmailError}
                onChangeAction={this.onRecoverPasswordEmailChange}
              />
            )}
            {!this.state.recoverPasswordStatus && (
              <NanoFlex className="notificationsWrapper">
                {/*ERROR NOTIFICATION*/}
                {this.state.recoverPasswordStatus === false && (
                  <NanoFlex className="alertNotificationContainer">
                    <NanoFlex className="alertNotificationWrapper errorNotification">
                      <NanoFlex className="alertWrapper">
                        <NanoFlex className="iconWrapper">
                          <Warning />
                        </NanoFlex>
                        <NanoFlex className="notificationWrapper" justifyContent={"flex-start"} alignContent={"flex-start"}>
                          <Type.p>{this.translation.passwordManagement.recoverPassword.errorMessage}</Type.p>
                        </NanoFlex>
                      </NanoFlex>
                    </NanoFlex>
                  </NanoFlex>
                )}
              </NanoFlex>
            )}
            {/*SUCESS NOTIFICATION*/}
            {this.state.recoverPasswordStatus === true && (
              <NanoFlex className="wrapperNotification" flexDirection="column">
                <NanoFlex className="iconWrapper">
                  <Check />
                </NanoFlex>

                <NanoFlex className="infoNotification">
                  <Type.h3>{this.translation.passwordManagement.recoverPassword.successMessage}</Type.h3>
                </NanoFlex>
              </NanoFlex>
            )}

            <NanoFlex className="btnsContainer" alignContent={"flex-end"}>
              <Button label={this.state.recoverPasswordStatus === true ? this.translation.geral.continue : this.translation.geral.cancel} type={"button"} simple={this.state.recoverPasswordStatus !== true} clickAction={this.cancelRecoverPassword} />
              {!this.state.recoverPasswordStatus && <Button id={0} label={this.translation.geral.send} type={"submit"} disable={this.state.recoverPasswordDisabled} />}
            </NanoFlex>
          </form>
        )}
      </PasswordManagementModalStyle>
    );
  }
}

// Set default props
PasswordManagementModal.defaultProps = {
  cancelAction: () => null,
  nextAction: () => null,
};

export default PasswordManagementModal;

/*
  Doc
  import PasswordManagementModal from '../../Micro/PasswordManagementModal.js';
  
  <PasswordManagementModal
      cancelAction={() => console.log('cancelAction')}
      nextAction={() => console.log('nextAction')}
  />
  */
